import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useFlipOnMove } from '../flow/useFlipOnMove';
import './QuestionBanner.css';

/**
 * The question, once asked. It is on the page exactly once from then on:
 * first under the reading types and over the deck, and once the cards are
 * picked, on top of them.
 *
 * Those are two places in one column, and this is one element that moves
 * between them — its slot is a CSS `order` (FlowStep.css), so the node is
 * never unmounted and useFlipOnMove can carry it across.
 */
function QuestionBanner({ question, mode, atCards, canEdit = false, onEdit }) {
  const { t } = useTranslation();
  const ref = useRef(null);
  useFlipOnMove(ref, atCards);

  return (
    <div ref={ref} className={`question-banner ${atCards ? 'is-at-cards' : ''}`}>
      <p className="question-banner__eyebrow">{t(`question.eyebrow.${mode}`)}</p>

      <blockquote className="question-banner__text">{question}</blockquote>

      <div className="question-banner__rule" aria-hidden="true">
        <span className="question-banner__diamond" />
      </div>

      {/* Only while the deck is untouched: the flow refuses a reword after
          that, and a button that does nothing is worse than none */}
      {canEdit && (
        <button
          type="button"
          className="question-banner__edit"
          onClick={onEdit}
          title={t('question.edit')}
        >
          {t('question.edit')}
        </button>
      )}
    </div>
  );
}

export default QuestionBanner;
